export enum ErrorTypes {
  productNotFound = 1
}
